import { sendAnalyticEvent } from "src/utils/analytics/sendAnalyticEvent";


export const sendDeliveryContractSet = (type: string) => {
  sendAnalyticEvent({
    'event': 'delivery_contract_set',
    'delivery_type': type,
  });
};
